import moment from "moment";

export const buildUserProfile = ({
  name,
  language,
  culturalBg,
  gender,
  birthday,
  countryCode,
  invitedBy,
  pushToken,
}) => {
  const data = {
    name: name.trim(),
    language,
    call_language: language,
  };

  if (countryCode) data.country_code = countryCode;
  if (culturalBg && culturalBg.trim() !== "") data.cultural_background = culturalBg.trim();
  if (gender && gender !== "prefer_not_to_say") data.gender = gender;
  if (birthday) data.birthdate = moment(birthday).format("yyyy-MM-DD");
  if (invitedBy != null) data.invited_by = invitedBy;
  if (pushToken) {
    data.push_token_platform = "web";
    data.push_token = pushToken;
  }

  return data;
};
